import { BadgeCheck, CircleX, Info, Star, TriangleAlert } from 'lucide-react';

type AnswerEvaluationProps = {
  evaluation?: any;
};

const AnswerEvaluation = ({ evaluation, ...props }: AnswerEvaluationProps) => {
  if (!evaluation) {
    return null;
  }
  return (
    <div {...props} className="flex items-center">
      {(() => {
        if (!evaluation || !evaluation?.name || evaluation?.name === 'info') {
          return <Info className="text-info" />;
        } else if (evaluation?.name === 'warning') {
          return <TriangleAlert className="text-warning" />;
        } else if (evaluation?.name === 'disqualified') {
          return <CircleX className="text-danger" />;
        } else if (evaluation?.name === 'bonus') {
          return (
            <div className="text-success flex font-semibold">
              <Star />
              <span>{evaluation?.bonus_points}</span>
            </div>
          );
        } else if (evaluation?.name === 'auto_qualified') {
          return <BadgeCheck className="text-evaluation-qualified" />;
        }
      })()}
    </div>
  );
};

export default AnswerEvaluation;
